<template>
    <div>
        <div class="info__wrapper" v-if="brasterAllowed">
            <img class="info__icon" src="../../../assets/images/icons/ico-ok-green.png" />
            <span class="info__status">{{ $t('YES') }}</span>
            <a class="arrow-link" @click="initiate()">
                {{ $t('CHECK_IF_DATA_ACTUAL') }}
                <img class="link__img" src="../../../assets/images/arrow-red.png" />
            </a>
        </div>
        <div class="info__wrapper" v-else>
            <img class="info__icon" src="../../../assets/images/icons/ico-not-ok.png" />
            <span class="info__status">{{ $t('NO') }}</span>
            <a class="arrow-link" @click="initiate()">
                {{ $t('CHECK_IF_DATA_ACTUAL') }}
                <img class="link__img" src="../../../assets/images/arrow-red.png" />
            </a>
        </div>

        <section v-if="checkIfAllowed">
            <!--1/4-->
            <survey-step2-q1 v-if="survey.section2.active_section === 1" :single="true"></survey-step2-q1>

            <!--2/4-->
            <survey-step2-q2 v-if="survey.section2.active_section === 2" :single="true"></survey-step2-q2>

            <!--3/4-->
            <survey-step2-q3 v-if="survey.section2.active_section === 3" :single="true"></survey-step2-q3>

            <!--4/4-->
            <survey-step2-q4
                v-if="survey.section2.active_section === 4"
                :single="true"
                type="inline"
                @close="hideInfoSection(true)"
            ></survey-step2-q4>

            <!--braster disallowed by pregnant-->
            <survey-disallowed-by-pregnant
                @close="hideInfoSection(false)"
                v-if="survey.section2.disallow_by_pregnant"
            ></survey-disallowed-by-pregnant>

            <!--braster disallowed by breast cancer-->
            <survey-disallowed-by-breast-cancer
                @close="hideInfoSection(false)"
                v-if="survey.section2.disallow_by_breast_cancer"
            ></survey-disallowed-by-breast-cancer>

            <!--braster disallowed by breast surgery-->
            <survey-disallowed-by-breast-surgery
                @close="hideInfoSection(false)"
                v-if="survey.section2.disallow_by_breast_surgery"
            ></survey-disallowed-by-breast-surgery>

            <!--braster disallowed by breast enlargament-->
            <survey-disallowed-by-breast-enlargament
                @close="hideInfoSection(false)"
                v-if="survey.section2.disallow_by_breast_enlargement"
            ></survey-disallowed-by-breast-enlargament>
        </section>
    </div>
</template>

<script>
import surveyStep2Q1 from '../../modals/main-survey/survey-step2-q1.vue';
import surveyStep2Q2 from '../../modals/main-survey/survey-step2-q2.vue';
import surveyStep2Q3 from '../../modals/main-survey/survey-step2-q3.vue';
import surveyStep2Q4 from '../../modals/main-survey/survey-step2-q4.vue';
import surveyDisallowedByPregnant from '../../modals/main-survey/survey-disallowed-by-pregnant.vue';
import surveyDisallowedByBreastCancer from '../../modals/main-survey/survey-disallowed-by-breast-cancer.vue';
import surveyDisallowedByBreastSurgery from '../../modals/main-survey/survey-disallowed-by-breast-surgery.vue';
import surveyDisallowedByBreastEnlargament from '../../modals/main-survey/survey-disallowed-by-breast-enlargament.vue';

export default {
    data() {
        return {
            checkIfAllowed: false,
        };
    },
    computed: {
        brasterAllowed() {
            return (
                this.$store.getters.brasterAllowed &&
                this.$store.state.survey.survey.section2.q1 === 'NO' &&
                this.$store.state.survey.survey.section2.q2 === 'NO' &&
                this.$store.state.survey.survey.section2.q3 === 'NO' &&
                this.$store.state.survey.survey.section2.q4 === 'NO'
            );
        },
        survey() {
            return this.$store.getters.survey;
        },
    },
    methods: {
        hideInfoSection(status) {
            this.checkIfAllowed = false;
            this.$store.dispatch('setBrasterPermission', {
                brasterAllowed: status,
            });
        },
        initiate() {
            this.checkIfAllowed = true;
        },
    },
    components: {
        surveyStep2Q1,
        surveyStep2Q2,
        surveyStep2Q3,
        surveyStep2Q4,
        surveyDisallowedByPregnant,
        surveyDisallowedByBreastCancer,
        surveyDisallowedByBreastSurgery,
        surveyDisallowedByBreastEnlargament,
    },
};
</script>

<style lang="scss">
.info {
    &__wrapper {
        padding: 5px 0 5px 60px;
        position: relative;
    }

    &__icon {
        position: absolute;
        left: 0;
        top: 0;
        width: 44px;
    }

    &__status {
        font-size: 20px;
        line-height: 1;
        margin: 0 0 10px;
        font-weight: 700;
    }
}

.arrow-link {
    cursor: pointer;

    .link__img {
        margin-left: 3px;
        width: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// braster-allowed.vue?df8c9934